import { updatePanelClasses } from '../models/panel';
import { selectors } from '../elements/constants';

function getActiveFirstPanel(form) {
  if (!form) return;
  return form.querySelector(`${selectors.activePanel}:first-child`);
}

/**
 * Animates the current active panel to slide in when showing the form.
 * @param {Element} leadform - The current form wizard
 */
export default function slideActiveFirstPanel(leadform) {
  if(leadform.classList.contains('form-wizard--hero')) { return; }

  const panel = getActiveFirstPanel(leadform);
  if(!panel) { return; }

  // move it back into active state after refresh
  return new Promise((resolve) => {
    // move the panel off screen
    updatePanelClasses(panel, { active: false });

    window.setTimeout(() => {
      updatePanelClasses(panel, { active: true });
      resolve();
    }, 1);
  });
}
